import { render, staticRenderFns } from "./homeWork.vue?vue&type=template&id=65873370&scoped=true"
import script from "./homeWork.vue?vue&type=script&setup=true&lang=js"
export * from "./homeWork.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65873370",
  null
  
)

export default component.exports